import React, {useContext} from 'react';
import {Flex, Text, textEllipsis, Box} from '@100mslive/react-ui';
import {SpeakerIcon} from '@100mslive/react-icons';
import {
  useHMSStore,
  selectDominantSpeaker,
  selectLocalPeerRoleName,
} from '@100mslive/react-sdk';
import {ParticipantList} from './ParticipantList';
import {AdditionalRoomState} from './AdditionalRoomState';
// import PIPComponent from '../PIP/PIPComponent';
import {AppContext} from '../context/AppContext';
import {DEFAULT_HLS_VIEWER_ROLE} from '../common/constants';
import PIPComponent from '../PIP/PIPComponent';
import {decryptText} from '../../utils/CommonFunction';

const SpeakerTag = () => {
  const dominantSpeaker = useHMSStore(selectDominantSpeaker);
  return dominantSpeaker && dominantSpeaker.name ? (
    <Flex
      align="center"
      justify="center"
      css={{flex: '1 1 0', color: '$textPrimary', '@md': {display: 'none'}}}>
      <SpeakerIcon width={24} height={24} />
      <Text
        variant="md"
        css={{...textEllipsis(200), ml: '$2'}}
        title={dominantSpeaker.name}>
        {decryptText(dominantSpeaker.name)}
      </Text>
    </Flex>
  ) : (
    <></>
  );
};

export const Logo = () => {
  const {logo} = useContext(AppContext);
  return (
    // <Image source={require(logo)} alt="Brand Logo" width={132} height={40} />
    <p>Logo image tag </p>
  );
};

export const Header = ({isPreview}: any) => {
  const localPeerRole = useHMSStore(selectLocalPeerRoleName);
  const showPip = localPeerRole !== DEFAULT_HLS_VIEWER_ROLE && !isPreview;
  return (
    <Flex
      justify="between"
      align="center"
      css={{position: 'relative', height: '100%'}}>
      <Flex align="center" css={{position: 'absolute', left: '$4'}}>
        {/* <Logo /> */}
      </Flex>
      <SpeakerTag />
      <Flex align="center" css={{position: 'absolute', right: '$4'}}>
        {showPip && <PIPComponent />}
        <AdditionalRoomState />
        <Box css={{mx: '$2'}}>
          <ParticipantList />
        </Box>
      </Flex>
    </Flex>
  );
};
